import { DocumentSubtract, DocumentTasks } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import { clsx, colorSet } from '@components/Provider';
import {
  CapaConsultingStartMethod,
  RegisterRfqInput
} from '@generated/graphql';

import useRequest from '@hooks/useRequest';
import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import FormInputLayout from '../Layout/FormInputLayout';

export default function ConsultMethodControl(): JSX.Element {
  const classes = useStyles();

  const { consultingStartMethod, onUpdateRfqInfo } = useRequest();

  const { control } = useFormContext<RegisterRfqInput>();

  return (
    <FormInputLayout label="견적서 필수 여부 선택" required={true}>
      <Controller
        control={control}
        rules={{
          required: {
            message: '상담 시작 방식을 선택해주세요',
            value: true
          }
        }}
        name="consultingStartMethod"
        defaultValue={CapaConsultingStartMethod.QuotationRequired}
        render={({ onChange }) => (
          <Grid item className={classes.methodContainer}>
            <Box
              className={clsx(classes.methodCard, {
                selected:
                  consultingStartMethod ===
                  CapaConsultingStartMethod.QuotationRequired
              })}
              onClick={(e) => {
                onChange(CapaConsultingStartMethod.QuotationRequired);
                onUpdateRfqInfo({
                  consultingStartMethod:
                    CapaConsultingStartMethod.QuotationRequired
                });
              }}
            >
              <Grid>
                {consultingStartMethod ===
                CapaConsultingStartMethod.QuotationRequired ? (
                  <DocumentTasks size={21} />
                ) : (
                  <DocumentSubtract size={21} color={colorSet.gray700} />
                )}
              </Grid>
              <Grid>
                <CustomizedTypography
                  variant="body1"
                  fontWeight="500"
                  color="textPrimary"
                >
                  견적서를 제출한 경우에만 상담할래요
                </CustomizedTypography>
                <CustomizedTypography variant="body2" color="textSecondary">
                  여러 견적을 직접 비교해볼 수 있습니다.
                  <br />
                  상대적으로 상담 기회가 적을 수 있습니다.
                </CustomizedTypography>
              </Grid>
            </Box>

            <Box
              className={clsx(classes.methodCard, {
                selected:
                  consultingStartMethod ===
                  CapaConsultingStartMethod.PartnerIntroductionAvailable
              })}
              onClick={(e) => {
                onChange(
                  CapaConsultingStartMethod.PartnerIntroductionAvailable
                );
                onUpdateRfqInfo({
                  consultingStartMethod:
                    CapaConsultingStartMethod.PartnerIntroductionAvailable
                });
              }}
            >
              <Grid>
                {consultingStartMethod ===
                CapaConsultingStartMethod.PartnerIntroductionAvailable ? (
                  <DocumentTasks size={21} />
                ) : (
                  <DocumentSubtract size={21} color={colorSet.gray700} />
                )}
              </Grid>
              <Grid>
                <CustomizedTypography
                  variant="body1"
                  fontWeight="500"
                  color="textPrimary"
                >
                  견적서가 없으면 회사소개서라도 받아요
                </CustomizedTypography>
                <CustomizedTypography variant="body2" color="textSecondary">
                  더 많은 파트너와 상담할 수 있습니다.
                  <br />
                  견적이 없을 경우엔 '회사소개서'를 제공합니다.
                </CustomizedTypography>
              </Grid>
            </Box>
          </Grid>
        )}
      ></Controller>
    </FormInputLayout>
  );
}

const useStyles = makeStyles((theme) => ({
  methodContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  methodCard: {
    maxWidth: 464,
    height: 110,
    backgroundColor: colorSet.gray000,
    border: `1px solid ${colorSet.gray400}`,
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    padding: `22px 20px 22px 20px`,
    gap: '17.5px',
    '&.selected': {
      backgroundColor: colorSet.gray100,
      border: `1px solid ${colorSet.gray900}`
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'none'
    },
    cursor: 'pointer'
  }
}));
